import { VehicleProtectionProvider } from '@makemydeal/dr-activities-vehicle-protection';
import type { SlideOutComponentProps } from '../../types';
import { ProtectionProductSlideOutContent } from './ProtectionProductSlideOutContent';

export const ProtectionProductSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    return (
        <VehicleProtectionProvider isOpen={isOpen}>
            <ProtectionProductSlideOutContent isOpen={isOpen} onClose={onClose} />
        </VehicleProtectionProvider>
    );
};
